<template>
  <div class="login">
    <div class="container">
      <v-snackbar v-model="loginSuccess" color="success" top>
        <span class="subtitle-1">Sucesso! Acessando sistema...</span>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top>
        <span class="subtitle-1">{{ mensagemLogin }}</span>
        <v-btn text class="warning white--text" @click="loginFail = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">Acesso ao sistema</h1>
      <v-divider></v-divider>
      <v-row class="mt-4" wrap justify="center">
        <v-flex v-if="habilitadoAutenticacaoPessoaFisica || habilitadoAutenticacaoPessoaJuridica" xs12 sm4 xl3>
          <v-card style="height: 400px" hover class="ma-3">
            <v-card-title>{{ tituloAutenticacaoPessoa }}</v-card-title>
            <v-card-text>
              <v-form ref="form" :class="recapchaObrigatorio ? '' : 'my-2' ">
                <v-text-field
                    v-if="habilitadoAutenticacaoPessoaFisica && !habilitadoAutenticacaoPessoaJuridica"
                    v-model="cpfCnpj"
                    name="cpfCnpj"
                    v-mask="['###.###.###-##']"
                    clearable
                    :rules="regrasCPF"
                    :label="loginAutenticacaoPessoa"
                    required
                    prepend-icon="account_circle"
                    autocomplete="off"/>
                <v-text-field v-else-if="habilitadoAutenticacaoPessoaJuridica && !habilitadoAutenticacaoPessoaFisica"
                              v-model="cpfCnpj"
                              name="cpfCnpj"
                              v-mask="['##.###.###/####-##']"
                              clearable
                              :rules="regrasCPF"
                              :label="loginAutenticacaoPessoa"
                              required
                              prepend-icon="account_circle"
                              autocomplete="off"/>
                <v-text-field v-else-if="habilitadoAutenticacaoPessoaJuridica && habilitadoAutenticacaoPessoaJuridica"
                              v-model="cpfCnpj"
                              name="cpfCnpj"
                              v-mask="['###.###.###-##', '##.###.###/####-##']"
                              clearable
                              :rules="regrasCPF"
                              :label="loginAutenticacaoPessoa"
                              required
                              prepend-icon="account_circle"
                              autocomplete="off"/>

                <v-text-field
                    v-model="senha"
                    name="senha"
                    :rules="regrasSenha"
                    :label="senhaAutenticacaoPessoa"
                    :type="mostrarSenha ? 'text' : 'password'"
                    required
                    prepend-icon="lock"
                    :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
                    @click:append="mostrarSenha = !mostrarSenha"
                    @keydown.enter="acessarSistema"
                    autocomplete="off"
                />

                <div>
                  <vue-recaptcha id="g-recaptcha"
                                 ref="recaptcha"
                                 language="pt-BR"
                                 @verify="onVerify"
                                 :sitekey="sitekey"
                                 :loadRecaptchaScript="true"
                                 required>
                  </vue-recaptcha>
                  <template v-if="recapchaObrigatorio">
                    <span class="small" style="color: orange;">Campo obrigatório!</span>
                  </template>
                </div>

<!--                <v-btn small text color="primary" class="mt-3" router to="senha">-->
<!--                  Esqueceu sua senha?-->
<!--                </v-btn>-->

                <v-btn small text class="mt-3 mb-4" @click="solicitaSenha" v-show="habilitadoCardPrimeiroAcesso">Esqueceu sua senha?</v-btn>
                <v-divider ></v-divider>
              </v-form>
              <v-card-actions class="mt-0">
                <v-btn small dark block color="primary" type="submit" @click="acessarSistema">
                  <v-icon small left>exit_to_app</v-icon>
                  <span>Entrar</span>
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex v-if="habilitadoAutenticacaoCertificadoDigital" xs12 sm4 md4>
          <v-card style="height: 400px" hover class="ma-3">
            <v-card-title>{{ tituloAutenticacaoCertificadoDigital }}</v-card-title>
            <v-card-text>
              <p class="body-2" style="text-align: justify">
                {{ mensagemAutenticacaoCertificadoDigital }}
              </p>
              <p style="text-align: justify; margin-bottom: 0">
                <strong class="red--text">ATENÇÃO:</strong>
                <span class="text-sm-caption">
                  {{ mensagemAtencaoAutenticacaoCertificadoDigital }}
                </span>
              </p>
            </v-card-text>
            <v-card-actions style="margin-top: auto">
              <v-divider class="mt-11"></v-divider>
              <v-btn small block color="primary" dark type="submit" :href="linkCertificadoDigital">
                <v-icon small left>account_balance_wallet</v-icon>
                <span>Utilizar certificado</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex v-if="habilitadoAutenticacaoExterno" xs12 sm4 md4>
          <v-card style="height: 400px" hover class="ma-3">
            <v-card-title>{{ tituloAutenticacaoExterno }}</v-card-title>
            <v-card-text style="height: 240px">
              <v-img
                  style="margin: auto"
                  class="ma-auto mb-4"
                  :src="`data:image/png;base64,${imagemAutenticacaoExterno}`"
              />

              <v-img height="70px" width="200px" class="ma-auto mb-4"
                     :src="`data:image/png;base64,${imagemSecundariaAutenticacaoExterno}`"
              />
              <!--                     src="@/assets/govbr-logo.png"-->

              <p class="body-2" style="text-align: justify">
                {{ mensagemAutenticacaoExterno }}
              </p>
            </v-card-text>
            <v-divider class="mt-13"></v-divider>
            <v-card-actions>
              <v-btn small block color="primary" dark type="submit" :href="urlAutenticacaoExterno">
                <v-icon small left>mdi-radiobox-marked</v-icon>
                <span>{{ tituloAutenticacaoExterno }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import {mask} from "vue-the-mask";
import crypto from "crypto-js";
import {base_url} from "../global";
import {httpNF} from "../axios.config";

import VueRecaptcha from 'vue-recaptcha';
import EventService from "@/services/EventService";

export default {
  directives: {mask},
  data() {
    return {
      cpfCnpj: "",
      senha: "",
      regrasCPF: [(v) => !!v || "Campo obrigatório!"],
      regrasSenha: [(v) => !!v || "Campo obrigatório!"],
      mostrarSenha: false,
      loginSuccess: false,
      loginFail: false,
      robot: false,
      recapchaObrigatorio: false,
      sitekey: "6LdDxykTAAAAACS27scPiLJUWafluxgV_jiov8Z1",
      linkCadastro: "",
      linkCertificadoDigital: "",
      mensagemLogin: "",

      habilitadoCardPrimeiroAcesso: false,

      habilitadoAutenticacaoPessoaFisica: false,
      habilitadoAutenticacaoPessoaJuridica: false,

      habilitadoAutenticacaoCertificadoDigital: false,
      tituloAutenticacaoCertificadoDigital: "",
      mensagemAutenticacaoCertificadoDigital: "",
      mensagemAtencaoAutenticacaoCertificadoDigital: "",

      habilitadoAutenticacaoExterno: false,
      tituloAutenticacaoExterno: "",
      imagemAutenticacaoExterno: "",
      imagemSecundariaAutenticacaoExterno: "",
      mensagemAutenticacaoExterno: "",
      urlCadastroExterno: "",
      urlAutenticacaoExterno: "",
    };
  },

  components: {
    'vue-recaptcha': VueRecaptcha
  },
  methods: {
    novoAcesso() {
      window.location.href = `${base_url}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?mostraCampoMatricula=N&faces-redirect=true`;
    },
    onVerify: function (response) {
      if (response) {
        this.robot = true;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    solicitaSenha() {
      return this.$router.push({
        name: 'SolicitarSenha',
        params: {
          cpf: this.habilitadoAutenticacaoPessoaFisica,
          cnpj: this.habilitadoAutenticacaoPessoaJuridica,
          permiteRedefinicaoEmail: this.permiteRedefinicaoEmail
        }
      });
    },
    acessarSistema() {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port == "8081" ? "8080" : window.location.port;
      // axios.defaults.baseURL = `${base_url}/controleacesso/servico/api/login`;

      // axios.defaults.baseURL = `${protocol}//${hostname}:${port}/controleacesso`;

      if (!this.robot) {
        this.recapchaObrigatorio = true;
      } else if (!this.$refs.form.validate()) {
        // console.log("Erro!");

        this.robot = false;
        this.$refs.recaptcha.reset();
      } else {
        this.recapchaObrigatorio = false;
        this.cpfCnpj = this.removeMask();
        this.senha = crypto.MD5(this.senha).toString();

        const loginform = {
          login: this.cpfCnpj,
          password: this.senha,
          identificacaoSistema: "NOTAFISCAL_EXTERNO",
          verificaSessao: false,
        };

        httpNF
            .post(
                //   `${this.cpfCnpj}/${this.senha}/sistema/NOTAFISCAL_EXTERNO`
                "acesso/login",
                loginform
            )
            .then((res) => {
              // console.log(res.data);
              this.loginSuccess = true;
              this.loginFail = false;
              this.campoObrigatorio = false;
              const token = res.data;
              window.location.replace(
                  `${base_url}/notafiscal/paginas/login/login.jsf?token=${token}`
              );
            })
            .catch((error) => {
              console.log(error);

              if (error.response !== undefined && error.response.data !== undefined && error.response.data['message'] !== undefined)
                this.mensagemLogin = error.response.data['message']
              else if (error.response !== undefined && error.response.data !== undefined)
                this.mensagemLogin = error.response.data
              else
                this.mensagemLogin = 'Algo deu errado! CPF/CNPJ ou senha incorretos.'

              this.loginFail = true;

              this.robot = false;
              this.$refs.recaptcha.reset();
            });
      }
    },
    removeMask() {
      return this.cpfCnpj.replace(/[^a-zA-Z0-9]/g, "");
    },
    abrePopUp() {
      window.open(this.getBaseUrl, 'Pagina', 'resizable=0,WIDTH=1024, HEIGHT=640')
    }
  },
  created() {
    this.linkCertificadoDigital = `${base_url}/notafiscal/certificadodigital/`;

    EventService.getConteudo().then(response => {
          this.habilitadoCardPrimeiroAcesso = response.data.habilitadoCardPrimeiroAcessoAvulsa;

          this.habilitadoAutenticacaoPessoaFisica = response.data.habilitadoAutenticacaoPessoaFisica;
          this.habilitadoAutenticacaoPessoaJuridica = response.data.habilitadoAutenticacaoPessoaJuridica;

          this.tituloAutenticacaoPessoa = response.data.tituloAutenticacaoPessoa;
          this.loginAutenticacaoPessoa = response.data.loginAutenticacaoPessoa;
          this.senhaAutenticacaoPessoa = response.data.senhaAutenticacaoPessoa;
          this.urlCadastroPessoaFisica = response.data.urlCadastroPessoaFisica;
          this.urlCadastroPessoaJuridica = response.data.urlCadastroPessoaJuridica;
          this.habilitadoAutenticacaoCertificadoDigital = response.data.habilitadoAutenticacaoCertificadoDigital;
          this.tituloAutenticacaoCertificadoDigital = response.data.tituloAutenticacaoCertificadoDigital;
          this.mensagemAutenticacaoCertificadoDigital = response.data.mensagemAutenticacaoCertificadoDigital;
          this.mensagemAtencaoAutenticacaoCertificadoDigital = response.data.mensagemAtencaoAutenticacaoCertificadoDigital;
          this.habilitadoAutenticacaoExterno = response.data.habilitadoAutenticacaoExterno;
          this.tituloAutenticacaoExterno = response.data.tituloAutenticacaoExterno;
          this.imagemAutenticacaoExterno = response.data.imagemAutenticacaoExterno;
          this.imagemSecundariaAutenticacaoExterno = response.data.imagemSecundariaAutenticacaoExterno;
          this.mensagemAutenticacaoExterno = response.data.mensagemAutenticacaoExterno;
          this.urlCadastroExterno = response.data.urlCadastroExterno;
          this.urlAutenticacaoExterno = response.data.urlAutenticacaoExterno;

          // if (this.habilitadoAutenticacaoPessoaFisica)
          this.opcoesCadastro.push({"opcao": "Pessoa Física", "url": this.urlCadastroPessoaFisica});

          // if (this.habilitadoAutenticacaoPessoaJuridica)
          this.opcoesCadastro.push({"opcao": "Pessoa Jurídica", "url": this.urlCadastroPessoaJuridica});

          // this.imagemRodape = response.data.imagemRodape;
          this.$vuetify.theme.themes.light.primary = response.data.corPrimaria;
          this.$vuetify.theme.themes.light.secondary = response.data.corSecundaria;
        }
    );
  },
  computed: {
    getBaseUrl() {
      /* return `${base_url}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?mostraCampoMatricula=N&faces-redirect=true`; */
      return `${base_url}/notafiscal/paginas/contribuintefora/contribuinteForaList.jsf?faces-redirect=true&incluir=S`;
    },
  },
};
</script>

<style>
.v-list .v-list-item:hover {
  background: lightskyblue;
  cursor: pointer;
}
</style>